// extracted by mini-css-extract-plugin
export default {"line":"RecurrenceLine_line__gsIre","text":"RecurrenceLine_text__j6xUH","label":"RecurrenceLine_label__0oUD6"};